export default {
  props: {
    logo: String,
    title: String,
    subtitle: {
      validator: () => true
    }
  }
};